// extracted by mini-css-extract-plugin
module.exports = {"ButtonInfo":"ButtonInfo_ButtonInfo__1rJYR"};